import React from "react";
import { createPortal } from "react-dom";
import { Citation } from "features/assistant/definitions";
import { citationLabel } from "./citations";
import styles from "../markdown.module.scss";

interface CitationHoverCardProps {
  citation: Citation;
  anchor: DOMRect;
}

/**
 * Hover preview for an inline citation marker, mirroring the standalone Answers
 * chatbot: a fixed-position card (portalled to <body> so it escapes overflow
 * clipping) showing the source title, page, and snippet.
 */
const CitationHoverCard: React.FC<CitationHoverCardProps> = ({
  citation,
  anchor,
}) => {
  const style: React.CSSProperties = {
    position: "fixed",
    top: anchor.bottom + 4,
    left: Math.max(8, anchor.left),
  };

  return createPortal(
    <div className={styles.citationHoverCard} style={style} role="tooltip">
      <div className={styles.citationHoverTitle}>{citationLabel(citation)}</div>
      {typeof citation.page === "number" && (
        <div className={styles.citationHoverPage}>Page {citation.page}</div>
      )}
      {citation.snippet && (
        <div className={styles.citationHoverSnippet}>{citation.snippet}</div>
      )}
    </div>,
    document.body,
  );
};

export default CitationHoverCard;
